import React from 'react';

/**
 * Component to display the Sara logo as an svg
 * @param {*} props - Generic parameter to pass along any desired props to the component
 */
const SvgSaraLogo = (props) => (
  <svg id="sara-logo" data-name="Layer 1" viewBox="0 0 78.5 78.5" {...props}>
    <title>SARA Logo</title>
    <defs>
      <style>
        {
          '.SaraLogo_svg__cls-1{fill:#231f20;stroke:#c00;stroke-miterlimit:3.86;stroke-width:3px}.SaraLogo_svg__cls-2{fill:#fcfdff}.SaraLogo_svg__cls-3{fill:#fff}'
        }
      </style>
    </defs>
    <path
      className="SaraLogo_svg__cls-1"
      d="M2.39 40.25A37.75 37.75 0 1 1 40.14 78 37.75 37.75 0 0 1 2.39 40.25z"
      transform="translate(-.89 -1)"
    />
    <path
      className="SaraLogo_svg__cls-2"
      d="M28.47 60.89a1.8 1.8 0 0 0-1.76-1.28c-.81 0-1.4.32-1.4 1.09 0 1.68 5.06 1.33 5.06 4.51 0 2-1.26 3-3.44 3a3.88 3.88 0 0 1-3.67-2.33l1.55-.68a2.24 2.24 0 0 0 2.13 1.54c.94 0 1.66-.35 1.66-1.3 0-1.94-5.06-1.55-5.06-4.57 0-1.76 1.47-2.75 3.17-2.75a3.57 3.57 0 0 1 3.47 2.21zM34.09 58.26h2.34l2.79 9.84h-1.87l-.54-2.1h-3.1l-.59 2.13h-1.86zm0 6.16h2.31l-1.1-4.27zM40.46 68.1v-9.83h3.92c2.23 0 3.12 1.3 3.14 2.91a2.44 2.44 0 0 1-1.8 2.54l2.17 4.38h-2.08l-1.81-4h-1.66v4zm1.88-5.53h1.38c1.47 0 1.92-.46 1.92-1.39s-.56-1.38-1.59-1.38h-1.71zM51.48 58.26h2.34l2.79 9.84h-1.87L54.2 66h-3.1l-.59 2.13h-1.86zm0 6.16h2.28l-1.1-4.27z"
      transform="translate(-.89 -1)"
    />
    <path
      className="SaraLogo_svg__cls-3"
      d="M26.68 28.65a5.07 5.07 0 0 0-5.07 5.06v13.65a5.06 5.06 0 0 0 5.07 5.06H38.4l-7.75-23.77zM52.71 28.65h-4L41 52.42h11.71a5.05 5.05 0 0 0 5.06-5.06V33.71a5.06 5.06 0 0 0-5.06-5.06zM49.05 19a9.36 9.36 0 1 0-9.35 9.36A9.36 9.36 0 0 0 49.05 19z"
      transform="translate(-.89 -1)"
    />
    <path
      d="M64.65 46.88a.87.87 0 0 0 .86-.86V28.24a.86.86 0 1 0-1.72 0V46a.86.86 0 0 0 .86.88zM62.88 29l-22.69 6.48v-.07a.86.86 0 0 0-1.72 0v3.44a.86.86 0 1 0 1.72 0v-.06l7.19 2.06-.49 1.54a1.89 1.89 0 0 0 1.29 2.34l5.26 1.51a1.84 1.84 0 0 0 1.43-.17 1.86 1.86 0 0 0 .9-1.12l.49-1.55 6.62 1.91zM49 41.31L54.68 43l-.49 1.54a.27.27 0 0 1-.12.15.25.25 0 0 1-.18 0l-5.26-1.51a.24.24 0 0 1-.16-.3zm11.87-10.46a.63.63 0 0 1 .35 1.22l-19.43 5.58a.63.63 0 1 1-.35-1.22z"
      transform="translate(-.89 -1)"
      fill="#c00"
    />
  </svg>
);

export default SvgSaraLogo;
